"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSchemaTypes;
exports.linkTypes = linkTypes;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function convertRawField(_ref) {
  var name = _ref.name,
    type = _ref.type;
  return {
    name: name,
    type: convertRawType(type)
  };
}
function convertRawFields(fields) {
  var convertedFields = {};
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      convertedFields[field.name] = convertRawField(field);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return convertedFields;
}
function convertRawType(_ref2) {
  var name = _ref2.name,
    kind = _ref2.kind,
    ofType = _ref2.ofType,
    fields = _ref2.fields;
  return {
    name: name,
    kind: kind,
    ofType: ofType ? convertRawType(ofType) : null,
    fields: fields ? convertRawFields(fields) : null
  };
}
function linkTypes(rawTypes) {
  var types = {};
  var _iterator2 = _createForOfIteratorHelper(rawTypes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var rawType = _step2.value;
      var _name3 = rawType.name;
      if (_name3) {
        types[_name3] = convertRawType(rawType);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  function resolveType(type, parent) {
    var _type = type,
      name = _type.name,
      ofType = _type.ofType;
    if (name && types[name]) type = types[name];
    if (ofType) type.ofType = resolveType(ofType, parent);
    if (parent) {
      var _type2 = type,
        parents = _type2.parents;
      if (!parents) type.parents = parents = [];
      parents.push(parent);
    }
    return type;
  }
  for (var _name in types) {
    var type = types[_name];
    var fields = type.fields;
    if (fields) {
      for (var _name2 in fields) {
        var field = fields[_name2];
        field.type = resolveType(field.type, field);
        field.parent = type;
      }
    }
  }
  return types;
}
function getSchemaTypes(_x) {
  return _getSchemaTypes.apply(this, arguments);
}
function _getSchemaTypes() {
  _getSchemaTypes = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fetchTypeMetadata) {
    var _yield$fetchTypeMetad, types;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchTypeMetadata();
        case 2:
          _yield$fetchTypeMetad = _context.sent;
          types = _yield$fetchTypeMetad.data.__schema.types;
          return _context.abrupt("return", linkTypes(types));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getSchemaTypes.apply(this, arguments);
}